<template>
	<div class="gloab-search-input" v-loading.fullscreen.lock="loading">
		<el-input placeholder="请输入表号进行搜索" v-model.trim="deviceNo" @keyup.enter.native.stop="handleSearch">
			<i slot="suffix" @click="handleSearch" class="el-input__icon el-icon-search"></i>
		</el-input>
		<el-collapse-transition>
			<div class="device-search-results" v-show="showSearchResult">
				<ul v-if="deviceList.length">
					<li
						v-for="item in deviceList"
						:key="`${item.deviceId || item.iotDeviceId || item.deviceNo}-${diagnosisMode(item)}`"
						@click="handleDiagnosisDetails(item)"
					>
						<span>{{ item.tenantName || item.deviceTypeName || '可用诊断来源' }} {{ item.deviceNo }}</span>
						<em>{{ diagnosisModeLabels[diagnosisMode(item)] }}</em>
					</li>
				</ul>
				<p class="empty-tip" v-else>暂无数据</p>
			</div>
		</el-collapse-transition>
	</div>
</template>

<script>
import { apiTraceDeviceList } from '@/apis/diagnosis.api'
import EventBus from '@/utils/eventBus'

export default {
	data() {
		return {
			diagnosisModeLabels: {
				DEFAULT: '云版物联网平台',
				CLOUD_LINK: '连接平台-云版',
				LOCAL_LINK: '连接平台-公共通信链路(终端测试)',
				NB_CONVERT: 'NB转换服务',
			},
			deviceNo: '',
			deviceList: [],
			showSearchResult: false,
			loading: false,
		}
	},
	methods: {
		handleSearch() {
			if (!this.deviceNo) return
			this.deviceList = []
			this.loading = true
			apiTraceDeviceList({ deviceNo: this.deviceNo, includeExternal: true })
				.then(res => {
					this.deviceList = res || []
					this.showSearchResult = true
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},
		/**
		 * 跳转通讯诊断设备详情
		 */
		handleDiagnosisDetails(item) {
			EventBus.$emit('communicate-diagnosis', item)
			this.deviceNo = ''
			this.showSearchResult = false
		},
		diagnosisMode(item) {
			return this.diagnosisModeLabels[item.diagnosisMode] ? item.diagnosisMode : 'DEFAULT'
		},

		/**
		 * 鼠标点击搜索框以外的区域隐藏下拉搜索列表
		 * @param {*} event
		 */
		elementClickOutside(event) {
			let nodeElement = event.target
			while (nodeElement) {
				if (nodeElement.className?.includes('gloab-search-input')) return
				nodeElement = nodeElement.parentNode
			}
			this.showSearchResult = false
		},
	},
	mounted() {
		document.addEventListener('click', this.elementClickOutside)
	},
	beforeDestory() {
		document.removeEventListener('click', this.elementClickOutside)
	},
}
</script>
<style lang="scss" scoped>
.gloab-search-input {
	position: relative;
	::v-deep {
		.el-input {
			.el-input__inner {
				height: 44px;
				border: none;
				background-color: #f0f3fc;
				width: 360px;
				font-size: 14px;
				padding-right: 50px;
				border-radius: 6px;
				color: #333;
				line-height: 22px;
				&::placeholder {
					color: #999;
				}
			}
			.el-input__suffix {
				top: 2px;
				right: 12px;
				cursor: pointer;
				.el-input__icon {
					font-size: 16px;
				}
			}
		}
	}
	.device-search-results {
		position: absolute;
		left: 1px;
		right: 1px;
		top: calc(100% + 7px);
		padding: 12px 8px 12px 12px;
		background-color: #fff;
		border-radius: 6px;
		box-shadow: inset 0 0 3px 0 hsla(0, 0%, 100%, 0.1), 0 0 3px 0 rgba(0, 0, 0, 0.14),
			0 8px 40px 0 rgba(0, 0, 0, 0.06);
		ul {
			max-height: 238px;
			overflow-y: scroll;
			padding-right: 8px;
			li {
				display: flex;
				align-items: center;
				justify-content: space-between;
				min-height: 38px;
				padding: 0 15px;
				cursor: pointer;
				border-radius: 4px;
				user-select: none;
				span {
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
				em {
					flex-shrink: 0;
					margin-left: 12px;
					color: #5f667d;
					font-size: 12px;
					font-style: normal;
				}
				& + li {
					margin-top: 2px;
				}
				&:hover {
					background-color: #f0f3fc;
					color: #2b57e8;
				}
			}
		}
		.empty-tip {
			padding: 30px;
			text-align: center;
			color: #999;
		}
	}
}
</style>
